import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const PromoCodeContainer = styled('div')`
  display: flex;
  width: 100%;
  margin-top: 20px;
`;
